import TagManager from 'react-gtm-module'

export function useGTM() {
  /**
   * Initialize Google Tag Manager via react-gtm-module.
   */
  const initGTM = () => {
    if (process.env.NEXT_PUBLIC_GOOGLE_TAG_MANAGER_ID && typeof window !== 'undefined') {
      try {
        const tagManagerArgs = {
          gtmId: process.env.NEXT_PUBLIC_GOOGLE_TAG_MANAGER_ID,
        }
        // eslint-disable-next-line no-constant-condition
        TagManager.initialize(tagManagerArgs)
      } catch (error) {
        console.error('GTM Initialization Error: ', error)
      }
    }
  }

  const logEventGTM = (params?: any) => {
    if (typeof window !== 'undefined') {
      try {
        // eslint-disable-next-line no-constant-condition
        TagManager.dataLayer({ ...params })
      } catch (error) {
        if (process.env.ENVIRONMENT !== 'production') {
          console.error('GTM Log Event Error:', error)
        }
      }
    }
  }

  // Braze helpers built on top of logEventGTM
  const brazeIdentify = (userId?: string | number) => logEventGTM({ dataLayer: { event: 'user_logged_in', user_id: String(userId) } })

  const brazeLogout = () => logEventGTM({ dataLayer: { event: 'user_logged_out' } })

  const brazeLogEvent = (eventName: string, properties: Record<string, any> = {}) =>
    logEventGTM({
      dataLayer: {
        event: eventName,
        braze_action: 'logCustomEvent',
        ...properties,
        _clear: true,
      },
    })

  return { initGTM, logEventGTM, brazeIdentify, brazeLogout, brazeLogEvent }
}
